import { render, staticRenderFns } from "./DevolucaoPropria.vue?vue&type=template&id=42b3673a&scoped=true&"
import script from "./DevolucaoPropria.vue?vue&type=script&lang=js&"
export * from "./DevolucaoPropria.vue?vue&type=script&lang=js&"
import style0 from "./DevolucaoPropria.vue?vue&type=style&index=0&id=42b3673a&scoped=true&lang=css&"
import style1 from "./DevolucaoPropria.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3673a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCard,VCardActions,VCol,VIcon,VRow,VTooltip})
